import styled from "@emotion/styled"
import { Grid } from "@mui/material"
import LeftSideJob from "./LeftSideJob"
import RightSideJob from "./RightSideJob"
import { COLOR_MAP } from "../../../../constants/ColorNames"

const Container = styled(Grid)`
    justify-content: space-evenly;
    padding:1.6rem 0;
    background-color: ${COLOR_MAP.WHITE};
     border-radius: 0.8rem;
    border: 0.1rem solid ${COLOR_MAP.BORDER_GREY};
   `

const JobDetails = () => {
    return (<Container container>
        <Grid item xs={5.7}>
            <LeftSideJob />
        </Grid>
        <Grid item xs={5.7} container rowSpacing='1rem'>
            <RightSideJob />
        </Grid>
    </Container>)
}

export default JobDetails